module.exports = __webpack_public_path__ + "img/1-11.c18e67ca.png";